import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, PrinterStroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { usePhieuThanhToanTamUngContext } from '../context';

interface ActionBarProps {
  onAdd: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onCopy: () => void;
  onSearch: () => void;
  onRefresh: () => void;
  onView: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export default function ActionBar({
  className,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onSearch,
  onRefresh,
  onView,
  isEditDisabled = true
}: ActionBarProps) {
  const { canExport, isExporting, exportToExcel } = usePhieuThanhToanTamUngContext();
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Phiếu thanh toán tạm ứng</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopy} disabled={isEditDisabled} />
      <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={() => {}} disabled={isEditDisabled} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onView} disabled={isEditDisabled} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Tìm kiếm',
            icon: <AritoIcon icon={12} />,
            onClick: onSearch,
            group: 0
          },
          {
            title: 'Xử lý chênh lệch',
            icon: <AritoIcon icon={772} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 2
          },

          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 2
          },
          {
            title: 'Xoá',
            icon: <AritoIcon icon={8} />,
            onClick: onDelete,
            group: 3
          }
        ]}
      />
    </ActionBarV2>
  );
}
